import { useMemo } from 'react';

import { useFormContext } from 'react-hook-form';

export const useErrorMessage = (name: string, label?: string) => {
  const { formState } = useFormContext();

  return useMemo(() => {
    const error = formState.errors[name];

    if (!error) {
      return undefined;
    }
    const { message } = error;

    if (message) {
      return String(message).replace(name, label || name);
    }

    return 'Field validation failed';
  }, [formState.errors, name, label]);
};
